import React, { Component, useState, useEffect, useContext } from "react";
import { hot } from "react-hot-loader";
import {
  Form,
  Input,
  Icon,
  Button,
  Upload,
  Spin,
  message,
  notification,
  Row,
  Col,
  List
} from "antd";
import TestCaseTagInput from "../TestCaseAdd/TestCaseTagInput";
import { TestCasePriorityInput } from "../TestCaseAdd/TestCasePriorityInput";
import { AppContext } from "../../AppContext";
import {
  CustomField,
  TestCasesApi,
  ProjectUsersApi
} from "../../services/generated-sdk";
import { TestCase } from "../../services/generated-sdk/models";
import { customFieldToAnt } from "../../utils/custom-field-handler";
import { getFormItem } from "../../utils/form-handler";
// import trackEvent from "../../common/utils";
// import { RcFile } from "antd/lib/upload";
import CenterElement from "./layout/CenterElement";
import { handleError } from "../../utils/common";
import { FormCreateOption } from "antd/lib/form";
const _ = require("lodash");

const FormItem = Form.Item;

function TestCaseQuickExtraFieldsForm(props: Props) {
  const { getFieldDecorator } = props.form;
  const [loadingCustomFields, setloadingCustomFields] = useState(false);
  const [saving, setSavingStatus] = useState(false);
  const { company } = React.useContext(AppContext);

  useEffect(() => {
    props.form.setFieldsValue({
      // ...result,
      tags: props.tags
      // suite: result.suite ? result.suite.id : undefined
    });
  }, []);
  const handleSubmit = e => {
    e.preventDefault();
    setSavingStatus(true);
    props.form.setFieldsValue({ add_new_test_case: 0 });

    props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        // saveTestCase(values);
        let customFieldsData = props.customFields.map(async cf => {
          let valueLabel = "";
          let color = "";
          if (values[cf.name] != undefined) {
            const value = values[cf.name];
            delete values[cf.name];
            if (cf.type === "dropdown") {
              cf.extra.options.map(o => {
                if (o.systemValue == value) {
                  valueLabel = o.label;
                }
              });
            }
            if (cf.type === "user") {
              const API = new ProjectUsersApi();
              try {
                let result = await API.getProjectUsers({
                  project: props.project,
                  filter: JSON.stringify({
                    user_contains: value,
                    "user.confirmed": true
                  })
                });
                if (result) {
                  const pUser = result[0];
                  valueLabel = pUser && pUser.user ? pUser.user.name : "NA";
                }
              } catch (e) {
                handleError(e.status);
              }
            }
            if (cf.type === "date") {
              valueLabel = value.format("YYYY-MM-DD");
            }
            return {
              id: cf.id,
              name: cf.name,
              value,
              label: cf.label,
              valueLabel,
              color
            };
          } else {
            let value = null;
            return {
              id: cf.id,
              name: cf.name,
              value,
              label: cf.label,
              valueLabel,
              color
            };
          }
        });
        const cfs = await Promise.all(customFieldsData);
        values["cfs"] = cfs.filter(cf => cf != null);
        props.pushQuickAddTestCase(values);
      } else {
        setSavingStatus(false);
      }
    });
  };

  return (
    <div className="white_wrapper">
      <h1>Add test case</h1>
      <Form onSubmit={handleSubmit}>
        <FormItem label="Priority" key="priority">
          {getFieldDecorator("priority", {
            initialValue: props.priority ? props.priority : "2"
          })(
            <TestCasePriorityInput
              initialValue={props.priority ? props.priority : "2"}
            />
          )}
        </FormItem>

        <FormItem label="Tags" key="tags">
          {getFieldDecorator("tags", { "option.initialValue": props.tags })(
            <TestCaseTagInput
              initialValue={props.tags}
              projectId={props.project}
              tagsEnabled={props.tagsAllowed}
            />
          )}
        </FormItem>

        <div style={{ display: props.canShowCF ? "block" : "none" }}>
          {loadingCustomFields ? (
            <Spin tip="loading custom fields..." />
          ) : (
            <Row gutter={24}>
              {props.customFields.map(cf => (
                <Col
                  key={`cf-${cf.id}`}
                  className="gutter-row"
                  span={cf.type == "textarea" || cf.type == "editor" ? 24 : 8}
                >
                  {getFormItem(
                    customFieldToAnt(
                      {
                        ...cf,

                        defaultValue:
                          props.CFValues[cf.name] &&
                          props.CFValues[cf.name]["value"]
                            ? props.CFValues[cf.name]["value"]
                            : cf.defaultValue
                      },
                      props.project,
                      company
                    ),
                    "",
                    getFieldDecorator
                  )}
                </Col>
              ))}
            </Row>
          )}
        </div>

        <br />
        <br />
        <FormItem key="title">
          {getFieldDecorator("title", { value: props.title })(
            <Input type="hidden" id="title" />
          )}
        </FormItem>
        <CenterElement>
          <Button type="primary" htmlType="submit" loading={saving}>
            Save
          </Button>{" "}
          &nbsp;
          <Button onClick={props.handleCancel} type="danger">
            Cancel
          </Button>
        </CenterElement>
      </Form>
    </div>
  );
}

interface Props {
  suite: number;
  project: number;
  priority: string;
  title: string;
  form: any;
  customFields: CustomField[];
  cfs: any[];
  tags: any[];
  CFValues: object;
  pushQuickAddTestCase: (values: object) => void;
  handleCancel: () => void;
  canShowCF: boolean;
  tagsAllowed: boolean;
}
const mapPropsToFields = { mapPropsToFields(props: Props) {} };
const FormOptions: FormCreateOption<Props> = mapPropsToFields;

const TestCaseQuickExtraFields = Form.create(FormOptions)(
  TestCaseQuickExtraFieldsForm
);

export default TestCaseQuickExtraFields;
